export default __webpack_public_path__ + "12cce838b8e4b29eee647432a022258f.png";